import React, { ReactNode } from 'react';
import { PartialSearchingProps, SearchingProps } from 'modules/Shared/type';
import { PageProps } from 'modules/Layout/type';
import { managePageAction, ManagePageAction } from 'modules/Layout/action';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import Listing from 'modules/Layout/component/Listing';
import DictionaryPagination from 'modules/Dictionary/container/Pagination';
import DictionaryPerPage from 'modules/Dictionary/container/PerPage';
import Dictionary from 'modules/Dictionary/model/Dictionary';
import { createSearchingProps } from 'modules/Shared/helper/params';
import { RootState } from 'app/reducer';
import {
  setDictionaryListParamsAction,
  SetDictionaryListParamsAction
} from 'modules/Dictionary/action/list';
import { breadcrumbRouteDictionaryList } from 'modules/Dictionary/breadcrumbs';
import DictionaryTable from 'modules/Dictionary/container/Table';
import DictionaryFilter from 'modules/Dictionary/container/Filter';
import { getPathUrl } from 'modules/Shared/helper/api';
import { ROUTE_DICTIONARY_ADD } from 'modules/Dictionary/routes';

export interface StateProps {
  fetching: boolean;
  type: string;
}

export interface DispatchProps {
  managePage: (payload: PageProps) => ManagePageAction;
  setParams: (payload: PartialSearchingProps) => SetDictionaryListParamsAction;
}

export interface Props extends StateProps, DispatchProps {
  table: string;
}

export const mapDispatch = (dispatch: Dispatch): DispatchProps => ({
  managePage: (payload: PageProps) => dispatch(managePageAction(payload)),
  setParams: (payload: PartialSearchingProps) =>
    dispatch(setDictionaryListParamsAction(payload))
});

export const mapState = (state: RootState): StateProps => {
  const { fetching } = state.dictionary.list;
  const { type } = state.layout.page;

  return { fetching, type };
};

export class DictionariesListView extends React.Component<Props> {
  protected searchProps: SearchingProps;

  constructor(props: Props) {
    super(props);

    this.searchProps = createSearchingProps(
      window.location.hash,
      Dictionary.getFilterableAttributes(),
      Dictionary.getSortableAttributes()
    );
  }

  componentDidMount(): void {
    const { managePage, setParams, table } = this.props;

    managePage({
      title: `Dictionaries ${Dictionary.getName(table)}`,
      breadcrumb: breadcrumbRouteDictionaryList(table)
    });

    setParams(this.searchProps);
  }

  render(): ReactNode {
    const { filter } = this.searchProps;
    const { fetching, type, table } = this.props;

    if (type) return null;

    return (
      <div className="row dictionaries-view">
        <div className="col-12">
          <Listing
            table={<DictionaryTable table={table} />}
            filter={<DictionaryFilter values={filter} />}
            pagination={<DictionaryPagination />}
            perPage={<DictionaryPerPage />}
            loading={fetching}
            addBtn={{
              text: 'Add position',
              url: getPathUrl(ROUTE_DICTIONARY_ADD, null, { table })
            }}
          />
        </div>
      </div>
    );
  }
}

export default connect<StateProps, DispatchProps>(
  mapState,
  mapDispatch
)(DictionariesListView);
